import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getWindowOrders } from "../../../utilities";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

// The user's exterior orders (same fetch as the Exterior Orders table,
// own-orders mode). The page renders newest last-in-list, so reverse for
// "most recent" — field keys are legacy strings with spaces.
const MyExteriorOrdersWidget = () => {
  const user = useSelector(selectUser);
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!user?.userID) return;
    getWindowOrders(
      user.userID,
      (data) => setOrders(Array.isArray(data) ? data : []),
      0
    );
  }, [user?.userID]);

  if (!orders) {
    return (
      <WidgetFrame title="My Exterior Orders" to="/windowdoor/exteriororders">
        <WidgetEmpty>Loading your orders…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const paymentDue = orders.filter((o) => o["Payment Outstanding"]).length;
  const recent = orders.slice(-3).reverse();

  return (
    <WidgetFrame title="My Exterior Orders" to="/windowdoor/exteriororders">
      <p className="flex items-baseline gap-1.5 text-sm">
        <span className="text-2xl font-semibold tabular-nums tracking-tight">{orders.length}</span>{" "}
        <span className="app-muted">orders</span>
        {paymentDue > 0 && (
          <span className="ml-1 self-center rounded-full bg-rose-500/15 px-2 py-0.5 text-xs font-semibold text-rose-700 dark:text-rose-300">
            {paymentDue} payment due
          </span>
        )}
      </p>
      {recent.length > 0 ? (
        <ul className="mt-2.5 space-y-1.5">
          {recent.map((order) => (
            <li
              key={order.OrderID}
              className="flex items-center justify-between gap-2 text-sm"
            >
              <span className="truncate font-medium">{order.Customer}</span>
              <span className="app-muted shrink-0 text-xs">{order.Status}</span>
            </li>
          ))}
        </ul>
      ) : (
        <WidgetEmpty>No orders yet.</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MyExteriorOrdersWidget;
